import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { createFileViews, handleSubCategories } from './utils';

import Heading from '../../Heading';
import InnerWrapper from '../../../global/InnerWrapper';
import MobileSelect from '../../../global/MobileSelect';
import LitAccordion from './LitAccordion';
import P from '../../../global/typography/P';
import AccordionTabGroup from '../Accordion/AccordionTabGroup';

const Desktop = styled.div`
  @media ${p => p.theme.media.largePhone} {
    display: none;
  }
`;

const Mobile = styled.div`
  display: none;
  @media ${p => p.theme.media.largePhone} {
    display: block;
  }
`;

function Literature({ literature, productSlug }) {
  // Literature is a nested array for categories and sub categories. For the initial state for litItems used on the
  // mobile view, I need to access the 1st item in the 1st nested array so that the 1st categories lit items display on mobile.
  const [litItems, setLitItems] = useState(literature[0][0].literature);
  const [hasSubCategories, setHasSubCategories] = useState(null);

  const filteredLiterature = [
    [...literature[0].filter(lit => productSlug === 'hot-water-generator' || lit.categoryName !== 'Custom Tank Quotations')],
    [...literature[1]]
  ];

  function handleChange(newCategory) {
    const selected = literature[0].find(
      category => category.categoryName === newCategory
    );

    setHasSubCategories(
      selected.subCategories.length > 0 && selected.subCategories
    );
    setLitItems(selected.literature);
  }

  /*
    The crest comparison chart was placed above the Literature section of the product sections per client request.
    This caused an issue with the scroll position when a user clicked either the technical documents button in the
    product header, or the Literature tab. The page would scroll to the crest comparison chart on the crest boiler
    and hellcat pages, and not the lit section. To fix this, we need to put the name attribute on the Inner wrapper of
    Literature component for those 2 pages.
  */

  const slugName =
    productSlug === 'crest-condensing-boiler' ||
    productSlug === 'crest-with-hellcat-combustion-technology'
      ? 'lit'
      : null;

  return (
    <InnerWrapper name={slugName}>
      <Desktop>
        <Heading>Literature</Heading>
        <P>See the product literature, manuals, etc...</P>
        <LitAccordion data={filteredLiterature} />
      </Desktop>
      <Mobile>
        <MobileSelect
          onChange={handleChange}
          options={filteredLiterature[0].map(category => category.categoryName)}
        />
        {createFileViews(litItems)}
        {hasSubCategories && (
          <AccordionTabGroup
            sections={handleSubCategories(
              hasSubCategories,
              filteredLiterature[1]
            )}
          />
        )}
      </Mobile>
    </InnerWrapper>
  );
}
export default Literature;

Literature.propTypes = {
  literature: PropTypes.array,
  productSlug: PropTypes.string
};
